import { DoubleBtnGroup, Logo } from 'components/Reusable';

import styles from './ErrorPageNotLogged.module.scss';

const ErrorPageNotLogged = (): JSX.Element => {
  return (
    <div className={styles.errorPage}>
      <div className={styles.errorHeader}>
        <Logo />
      </div>
      <div className={styles.contentContainer}>
        <span>Oops :(</span>
        <span>Sorry - we’re not able to load the page you’re looking for. Try refreshing in a bit.</span>
        <DoubleBtnGroup hideButton1 name2="Refresh" onClick2={() => window.location.reload()} />
      </div>
    </div>
  );
};

export default ErrorPageNotLogged;
